import React, { useState } from "react";
import { METRIC_BANDS, DEFAULT_VISIBLE_BANDS, ScenarioColumnPicker } from "./columnPickerShared";

export default function PriorVsCurrentForecastTab({
  classes, ContractTable, CF_TOTAL, CF_DATA,
  Q2_TOTAL, Q2_DATA, PRIOR_VAR_TOTAL, PRIOR_VAR_DATA, fmtVar,
  liveTitle, priorTitle, priorVersionName, periodMonthKeys,
  actualColumns, priorActualColumns, actualThroughMonth, priorActualThroughMonth, fiscalYear,
}) {
  const year = String(fiscalYear || "");
  const priorLabel = priorVersionName || "Q2 Forecast";
  const [visibleBands, setVisibleBands] = useState(DEFAULT_VISIBLE_BANDS);
  const toggle = (key) =>
    setVisibleBands((prev) =>
      prev.includes(key)
        ? prev.length > 1 ? prev.filter((k) => k !== key) : prev
        : [...prev, key].sort((a, b) =>
            METRIC_BANDS.findIndex((m) => m.key === a) - METRIC_BANDS.findIndex((m) => m.key === b))
    );

  const picker = <ScenarioColumnPicker visible={visibleBands} onToggle={toggle} />;
  const liveActualProps = { actualColumns, actualThroughMonth };
  /* The prior/Q2 table has its own actuals cutoff — falls back to the live
     table's cutoff only if the API didn't send a distinct one. */
  const priorActualProps = {
    actualColumns: priorActualColumns?.length ? priorActualColumns : actualColumns,
    actualThroughMonth: priorActualThroughMonth ?? actualThroughMonth,
  };

  return (
    <div>
      <ContractTable title={liveTitle || "Current Month Actuals + Live Forecast"}
        subtitle="Live Scenario" totalRow={CF_TOTAL} rows={CF_DATA} year={year}
        classes={classes} visibleBands={visibleBands} controls={picker} periodMonthKeys={periodMonthKeys}
        {...liveActualProps} />
      <ContractTable title={priorTitle || "Current Month Actuals + Prior Forecast"}
        subtitle="Prior Forecast Scenario" totalRow={Q2_TOTAL} rows={Q2_DATA} year={year}
        classes={classes} visibleBands={visibleBands} periodMonthKeys={periodMonthKeys}
        {...priorActualProps} />
      <ContractTable title="Variance"
        subtitle={`Live Forecast Vs ${priorLabel}`} totalRow={PRIOR_VAR_TOTAL} rows={PRIOR_VAR_DATA} year={year}
        classes={classes} formatter={fmtVar} visibleBands={visibleBands} periodMonthKeys={periodMonthKeys}
        {...liveActualProps} />
    </div>
  );
}
